import type { Pathway } from "../../types/pathway.types";
import { ahtDemographicConfiguration } from "./_shared/ahtDemographicBanner";

const OUT_CHAIN = "aht-sel-chain-out";

export const ahtWtSelectorPathway: Pathway = {
  id: "aht-wt-selector",
  name: "Weight Management (AHT)",
  population: "AHT weight management consultation",
  pgdRefs: [],
  demographicConfiguration: ahtDemographicConfiguration,
  entryNode: "aht-sel-type",

  nodes: [
    {
      id: "aht-sel-type",
      type: "single_select",
      text: "What type of consultation is this?",
      options: [
        { id: "initial",      label: "New patient — initial supply" },
        { id: "transfer",     label: "Transfer from another provider" },
        { id: "reinitiation", label: "Re-initiation — returning patient" },
      ],
      routing: {
        initial:      "aht-sel-chain-out",
        transfer:     "aht-sel-chain-out",
        reinitiation: "aht-sel-chain-out",
      },
      storesTo: "aht-sel-consultation-type",
      required: true,
    },
  ],

  outcomes: {
    [OUT_CHAIN]: {
      id: OUT_CHAIN,
      type: "outcome",
      outcomeType: "chain",
      title: "Loading pathway...",
      safetyNetting: [],
      chainId: "aht-wt-selector-chain",
    } as any,
  },
};
